import React, { useState } from 'react';

import { ReactComponent as ArrowDropdownIcon } from '@assets/svg/ic-dropdown.svg';

import style from '../style.module.scss';

interface IProps {
  values: string[];
  currentValue: string;
  onChange: (value: number) => void;
  type: DropdownTypes;
}

type DropdownTypes = 'months' | 'years';

const DatepickerHeaderDropdown = ({ values, currentValue, onChange, type }: IProps) => {
  const [isOpen, setIsOpen] = useState(false);
  const toggleDropdown = () => setIsOpen((prev) => !prev);

  const displayValue = type === 'months' ? values[Number(currentValue)] : currentValue;

  const handleOptionClick = (value: number | string) => {
    onChange(Number(value));
    setIsOpen(false);
  };

  return (
    <div className={style.customDropdown}>
      <div className={style.customDropdownHeader} onClick={toggleDropdown}>
        {displayValue}
        <ArrowDropdownIcon className={style.customDropdownIcon} />
      </div>
      {isOpen && (
        <div className={style.customDropdownMenu}>
          {values.map((value, index) => (
            <div
              key={index}
              className={style.customDropdownItem}
              onClick={() => handleOptionClick(type === 'months' ? index : value)}
            >
              {value}
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default DatepickerHeaderDropdown;
